import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_EXCHANGE_RATE_COLLECTION_NAME = "exchange-rate";

export const useRxCollectionExchangeRate =
  (): RxCollection<ExchangeRate> | null =>
    useRxCollection<ExchangeRate>(RXDB_EXCHANGE_RATE_COLLECTION_NAME);

const EXCHANGE_RATE_CURRENCIES = [
  "GHS",
  "KES",
  "LRD",
  "NGN",
  "PKR",
  "USD",
] as const;

const EXCHANGE_RATE_SOURCES = ["CBL"] as const;

const EXCHANGE_RATE_SCHEMA_LITERAL = {
  title: "exchange rate schema",
  version: 0,
  description:
    "A published rate between two billing currencies, as quote units per one base unit",
  type: "object",
  primaryKey: "id",
  properties: {
    id: { type: "string", maxLength: 100 },
    baseCurrency: { type: "string", enum: EXCHANGE_RATE_CURRENCIES },
    quoteCurrency: { type: "string", enum: EXCHANGE_RATE_CURRENCIES },
    buying: { type: "string" },
    selling: { type: "string" },
    mid: { type: "string" },
    effectiveDate: { type: "string", format: "date" },
    fetchedAt: { type: "string", format: "date-time" },
    source: { type: "string", enum: EXCHANGE_RATE_SOURCES },
    sourceUrl: { type: "string" },
    meta: SYNCABLE_META,
  },
  required: [
    "id",
    "baseCurrency",
    "quoteCurrency",
    "buying",
    "selling",
    "mid",
    "effectiveDate",
    "fetchedAt",
    "source",
    "sourceUrl",
    "meta",
  ],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(EXCHANGE_RATE_SCHEMA_LITERAL);

export type ExchangeRate = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const EXCHANGE_RATE_SCHEMA: RxJsonSchema<ExchangeRate> =
  EXCHANGE_RATE_SCHEMA_LITERAL;
